/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ yearly_price_month: NonNullable<unknown> }} New_User_Yearly_Subscription_FooterInputs */

const en_new_user_yearly_subscription_footer = /** @type {(inputs: New_User_Yearly_Subscription_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Equals ${i?.yearly_price_month}/month, cancel anytime.`)
};

const ar_new_user_yearly_subscription_footer = /** @type {(inputs: New_User_Yearly_Subscription_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`تعادل ${i?.yearly_price_month}/شهريًا، يمكنك الإلغاء في أي وقت.`)
};

const de_new_user_yearly_subscription_footer = /** @type {(inputs: New_User_Yearly_Subscription_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Entspricht ${i?.yearly_price_month}/Monat, jederzeit kündbar.`)
};

const es_new_user_yearly_subscription_footer = /** @type {(inputs: New_User_Yearly_Subscription_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Igual a ${i?.yearly_price_month} / mes, cancela en cualquier momento.`)
};

const fr_new_user_yearly_subscription_footer = /** @type {(inputs: New_User_Yearly_Subscription_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Soit ${i?.yearly_price_month}/mois, résiliable à tout moment.`)
};

const it_new_user_yearly_subscription_footer = /** @type {(inputs: New_User_Yearly_Subscription_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uguale a ${i?.yearly_price_month}/mese, annulla in qualsiasi momento.`)
};

const ja_new_user_yearly_subscription_footer = /** @type {(inputs: New_User_Yearly_Subscription_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.yearly_price_month}/月、いつでもキャンセル可能。`)
};

const ko_new_user_yearly_subscription_footer = /** @type {(inputs: New_User_Yearly_Subscription_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`월 ${i?.yearly_price_month} 꼴, 언제든지 취소 가능.`)
};

const pt_br_new_user_yearly_subscription_footer = /** @type {(inputs: New_User_Yearly_Subscription_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Equivale a ${i?.yearly_price_month}/mês, cancele quando quiser.`)
};

const ru_new_user_yearly_subscription_footer = /** @type {(inputs: New_User_Yearly_Subscription_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Составляет ${i?.yearly_price_month}/месяц, отменяйте в любое время.`)
};

const th_new_user_yearly_subscription_footer = /** @type {(inputs: New_User_Yearly_Subscription_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เท่ากับ ${i?.yearly_price_month}/เดือน ยกเลิกได้ทุกเมื่อ`)
};

const tr_new_user_yearly_subscription_footer = /** @type {(inputs: New_User_Yearly_Subscription_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fiyatı aylık ${i?.yearly_price_month} idir, istediğin zaman iptal edebilirsin.`)
};

const zh_cn_new_user_yearly_subscription_footer = /** @type {(inputs: New_User_Yearly_Subscription_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`相当于 ${i?.yearly_price_month}/月，随时可取消。`)
};

const zh_tw_new_user_yearly_subscription_footer = /** @type {(inputs: New_User_Yearly_Subscription_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`相當於 ${i?.yearly_price_month}/月，隨時可取消。`)
};

/**
* | output |
* | --- |
* | "Equals {yearly_price_month}/month, cancel anytime." |
*
* @param {New_User_Yearly_Subscription_FooterInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const new_user_yearly_subscription_footer = /** @type {((inputs: New_User_Yearly_Subscription_FooterInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_User_Yearly_Subscription_FooterInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_new_user_yearly_subscription_footer(inputs)
	if (locale === "ar") return ar_new_user_yearly_subscription_footer(inputs)
	if (locale === "de") return de_new_user_yearly_subscription_footer(inputs)
	if (locale === "es") return es_new_user_yearly_subscription_footer(inputs)
	if (locale === "fr") return fr_new_user_yearly_subscription_footer(inputs)
	if (locale === "it") return it_new_user_yearly_subscription_footer(inputs)
	if (locale === "ja") return ja_new_user_yearly_subscription_footer(inputs)
	if (locale === "ko") return ko_new_user_yearly_subscription_footer(inputs)
	if (locale === "pt_br") return pt_br_new_user_yearly_subscription_footer(inputs)
	if (locale === "ru") return ru_new_user_yearly_subscription_footer(inputs)
	if (locale === "th") return th_new_user_yearly_subscription_footer(inputs)
	if (locale === "tr") return tr_new_user_yearly_subscription_footer(inputs)
	if (locale === "zh_cn") return zh_cn_new_user_yearly_subscription_footer(inputs)
	return zh_tw_new_user_yearly_subscription_footer(inputs)
});